import EmptyGuard from "@/components/global/Empty";
import NotFoundIcon from "@/components/icons/NotFoundIcon";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

const NotFound = () => {
  return (
    <EmptyGuard
      data={[]}
      title="404 Page"
      description="try another keyword!"
      icon={<NotFoundIcon width={280} />}
    />
  );
};

export default NotFound;

export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "home"])),
    },
  };
}
